/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionlanguagede3Inputs */

const en_eventdescriptionlanguagede3 = /** @type {(inputs: Eventdescriptionlanguagede3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de_eventdescriptionlanguagede3 = /** @type {(inputs: Eventdescriptionlanguagede3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {Eventdescriptionlanguagede3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionlanguagede3 = /** @type {((inputs?: Eventdescriptionlanguagede3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionlanguagede3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionlanguagede3(inputs)
	return de_eventdescriptionlanguagede3(inputs)
});
export { eventdescriptionlanguagede3 as "eventDescriptionLanguageDe" }